import { Button } from "@/components/ui/button";
import { SmoothLink } from "@/components/providers/NavigationProvider";

export default function NavigationButtons() {
  return (
    <div className="flex items-center space-x-4">
      <SmoothLink href="/sign-in">
        <Button
          variant="ghost"
          className="text-gray-700 hover:text-gray-900 transition-all duration-300 hover:scale-105 cursor-pointer"
        >
          Sign in
        </Button>
      </SmoothLink>
      <SmoothLink href="/sign-up">
        <Button className="bg-[#1D9E75] hover:bg-[#1a8b66] text-white transition-all duration-300 hover:scale-105 hover:shadow-lg cursor-pointer">
          Get started
        </Button>
      </SmoothLink>
    </div>
  );
}
